import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { DashboardLayoutsBus } from '@app/cp/shared/models/DashboardLayoutsBus';
import { GlobalsService } from '../../shared/services/globals.service'
import { DashboardLayoutsBusParam } from '@app/cp/shared/models/DashboardLayoutsBusParam';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonFunctions } from '../../shared/static/common-functions';

@Component({
    selector: 'cp-dashboard-ribbon',
    templateUrl: './dashboard-ribbon.component.html',
    styleUrls: ['./dashboard-ribbon.component.scss']
})
export class DashboardRibbonComponent implements OnInit {

    constructor(private svc_dashboard: DashboardService, private svc_globals: GlobalsService) { }

    widgetLayouts: DashboardLayoutsBus[];
    selectedLayout: string;
    selectedLayoutName: string;
    public viewBuilder: boolean = false;
    public showFilter: boolean = false;
    showSaveWindow: boolean = false;
    public newLayoutValues: { layoutId: string, layoutName: string } = { layoutId: null, layoutName: '' };
    defaultLayoutCheck: boolean = false;
    deleteConfirmation: boolean = false;
    newOrUpdate: boolean = true;
    selectedLayoutGItem: any;

    @Input() widgets: any;
    @Output() changeWidgetLayout = new EventEmitter<string>();

    ngOnInit() {
        this.getLayouts();
    }

    getLayouts(resetLayout: boolean = true) {
        this.svc_dashboard.GetDashboardLayoutsByUsers().subscribe(data => {

            this.widgetLayouts = data;
            if (resetLayout) {
                this.changeLayout(this.widgetLayouts[0]?.defaultLayoutId);
            }
        });
    }

    manRefresh() {
        this.svc_dashboard.manRefresh();
    }

    compareString(layout) {
        return layout.layoutId == this.selectedLayout;
    }

    changeLayout(id: string) {
        this.selectedLayout = id;
        this.selectedLayoutGItem = {
            layoutId: this.selectedLayout,
            layoutName: this.selectedLayoutName,
        }
        this.changeWidgetLayout.emit(id);
    }

    layoutSelectionChanged(e) {
        this.changeLayout(e.layoutId);
    }

    toggleSaveWindow(state: boolean) {
        this.showSaveWindow = state;
    }

    setNewLayoutName(e) {
        if (CommonFunctions.hasGuidValue(e.layoutId)) {
            this.newOrUpdate = false;
            this.newLayoutValues.layoutName = e.layoutName;
            this.newLayoutValues.layoutId = e.layoutId;
        } else {
            this.newOrUpdate = true;
            this.newLayoutValues.layoutName = e.layoutName;
            this.newLayoutValues.layoutId = e.layoutId;
        }
    }

    public valueNormalizer = (text: Observable<string>) => text.pipe(map((text: string) => {
        return {
            layoutId: null,
            layoutName: text
        };
    }));

    saveLayout(layout: string) {
        this.showSaveWindow = false;
        let newLayout = new DashboardLayoutsBusParam();
        newLayout.layoutId = this.newLayoutValues ? this.newLayoutValues.layoutId : null;
        newLayout.layout = layout;
        newLayout.layoutName = this.newLayoutValues ? this.newLayoutValues.layoutName : '';
        newLayout.defaultLayout = this.defaultLayoutCheck;
        console.log("saveLayout: ", newLayout, this.newLayoutValues);
        this.svc_dashboard.SaveDashboardLayout(newLayout).subscribe(data => {
            this.setNotice(1);
            this.getLayouts(false);
        });
        this.defaultLayoutCheck = false;
        this.newLayoutValues.layoutId = null;
        this.newLayoutValues.layoutName = '';
    }

    setNotice(val: number) {
        switch(val) {
            case 1:
                this.svc_globals.notify("Layout Successfully Saved", "S", false, null);
            break;
            case 2:
                this.svc_globals.notify("Layout Successfully Deleted", "S", false, null);
            break;
        }
    }

    deleteLayout(layoutId: string) {
        if (this.deleteConfirmation) {
            this.svc_dashboard.DeleteDashboardLayout(layoutId).subscribe(data => {
                this.setNotice(2);
                this.getLayouts(false);
            });
        }
        this.newLayoutValues.layoutId = null;
        this.newLayoutValues.layoutName = '';
        this.deleteConfirmation = !this.deleteConfirmation;
    }

}